module.exports = __webpack_public_path__ + "img/Group-36529.a41b4e84.svg";